module.exports = __webpack_public_path__ + "static/img/message-empty.c9d4efab.png";